import React, { FC, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import dayjs from 'dayjs';

import { useAppSelector } from '~redux/hooks';
import navActions from '~utils/navActions';
import UtilFunctions from '~utils/functions';

const PrivateRoute: FC = () => {
    const {
        Auth: {
            getAuthToken,
        },
        SessionStorage: {
            getItem,
        },
    } = UtilFunctions;

    let isAuthenticated = useAppSelector(state => state.auth.userDetails.authToken);
    const authTokenExp = getItem<number>('authTokenExp');

    if (!isAuthenticated) isAuthenticated = getAuthToken() || '';

    useEffect(() => {
        if (!isAuthenticated || !authTokenExp || authTokenExp < dayjs().unix()) {
            navActions.navResetToLogin();
        }
    }, [isAuthenticated]);

    if (!isAuthenticated) return null;

    return (
        <div style={{ display: 'flex' }}>
            <Outlet />
        </div>
    );
};

export default PrivateRoute;
